import axios from "axios";
import { useEffect } from "react";
import { Category } from "../../../CRUD/CampSites/types";
import { PackageDTO, PricingModelDTO } from "../CategoryService";
import React from "react";

interface PackageDetailProps {
  pkg: PackageDTO;
  onClose: () => void;
}

const PackageDetail: React.FC<PackageDetailProps> = ({ pkg, onClose }) => {
  const [categories, setCategories] = React.useState<Category[]>([]);

  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("accessToken");

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get<{
          success: boolean;
          message: string | null;
          data: Category[];
        }>(`${apiUrl}/Category/getCategories`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data.success) {
          setCategories(response.data.data);
        } else {
          console.error("Error fetching categories:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, [apiUrl, token]);

  // Extract unique date ranges from the selected package's pricing models
  const dateRangeMap = new Map<string, { startDate: string; endDate: string; pricingModelIds: number[] }>();
  pkg.prices.forEach(price => {
    price.dateRanges.forEach(dateRange => {
      const dateRangeKey = `${dateRange.startDate}-${dateRange.endDate}`;
      if (!dateRangeMap.has(dateRangeKey)) {
        dateRangeMap.set(dateRangeKey, {
          startDate: dateRange.startDate,
          endDate: dateRange.endDate,
          pricingModelIds: [price.id]
        });
      } else {
        dateRangeMap.get(dateRangeKey)!.pricingModelIds.push(price.id);
      }
    });
  });
  const uniqueDateRanges = Array.from(dateRangeMap.values());

  // Extract unique pricing options
  const uniquePricingOptionsMap = new Map<string, PricingModelDTO>();
  pkg.prices.forEach(price => {
    const priceKey = JSON.stringify({
      description: price.description,
      price: price.price,
      discount: price.discount,
      minPersons: price.minPersons,
      maxPersons: price.maxPersons,
      bookedPersons: price.bookedPersons,
      chaletCapacity: price.chaletCapacity,
    });
    if (!uniquePricingOptionsMap.has(priceKey)) {
      uniquePricingOptionsMap.set(priceKey, price);
    }
  });
  const uniquePricingOptions = Array.from(uniquePricingOptionsMap.values());

  console.log("uniqueDateRanges:", uniqueDateRanges);

  return (
    <div className="package-detail mb-5 pb-5">
      <div className="package-header">
        <h3>{pkg.name}</h3>
        <button className="btn btn-outline-secondary" onClick={onClose}>
          Close
        </button>
      </div>
      <p>{pkg.description}</p>
      <p>Price From: {pkg.priceFrom}</p>
      <p>Max Group Size: {pkg.maxGroupSize}</p>
      {pkg.imageUrls.length > 0 && (
        <div className="package-images">
          <h5>Images:</h5>
          <div className="image-gallery">
            {pkg.imageUrls.map((image, index) => (
              <img
                key={index}
                src={image.url}
                alt={`Package Image ${index + 1}`}
                className={image.isMain ? "main-image" : ""}
              />
            ))}
          </div>
        </div>
      )}
      {uniqueDateRanges.length > 0 && (
        <div>
          <h5>Dates & Prices:</h5>
          <ul>
            {uniqueDateRanges.map((dateRange, index) => (
              <li key={index}>
                {dateRange.startDate} - {dateRange.endDate} (Pricing Models:{" "}
                {dateRange.pricingModelIds.join(", ")})
              </li>
            ))}
          </ul>
        </div>
      )}
      {uniquePricingOptions.length > 0 && (
        <div>
          <h5>Price per person:</h5>
          {uniquePricingOptions.map((price) => (
            <div key={price.id}>
              <p>Description: {price.description}</p>
              <p>Price: {price.price}</p>
              <p>Discount: {price.discount}</p>
              <p>Min Persons: {price.minPersons}</p>
              <p>Max Persons: {price.maxPersons}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PackageDetail;
